import { DownsampleRate } from '../../models/vessels/maritime-ais-api';

const HistoryPanelSampleRate: Record<string, DownsampleRate> = {
  ONE_HOUR: '1h',
  ONE_DAY: '1d',
  TEN_MINUTES: '10m',
};

export default HistoryPanelSampleRate;
